import vue from "vue";
import VueRouter from "vue-router";
import login from "../components/login/login.vue";
import main from "../components/main/Main.vue"
import registrati from "../components/registrati/registrati.vue";
import index from "../components/index/index.vue";
import prenota from "../components/prenota/prenota.vue";
// import proposte from "../components/prenota/proposte.vue";
// import riepilogo from "../components/prenota/riepilogo.vue";
import listaappuntamenti from "../components/appuntamenti/listaappuntamenti.vue";
import listaPendenze from "../components/pagamento/listaPendenze.vue";
import contatti from "../components/contatti/contatti.vue";
import contattaci from "../components/supporto/contattaci.vue";
import profilo from "../components/anagrafica/utente.vue";
import pagamentoConfermato from "../components/pagamento/pagamentoConfermato.vue";
import errorePagamento from "../components/pagamento/errorePagamento.vue";
import storicoPagamenti from "../components/pagamento/storicoPagamenti.vue";
import oauthRedirect from "../components/temp/oauthRedirect.vue"
import registratiSpid from "../components/registrati/registratiSpid.vue";
import faq from "../components/supporto/faq.vue";
import oauthRedirectFSE from "@/components/temp/oauthRedirectFSE.vue";
// import authService from '../oidcAuth.js';

vue.use(VueRouter);

let mainChildren = [
    {
        path: '/registrati',
        name: 'Registrati',
        component: registrati,
    },
    {
        path: "/profilo",
        name: "Profilo",
        component: profilo,
    },
    {
        path: '/index',
        name: 'Index',
        component: index,
    },
    {
        path: '/prenota',
        name: 'Prenota',
        component: prenota,
        beforeEnter: (to, from, next) => {
            var prenotazioneIsEnable = JSON.parse(sessionStorage.getItem("serviziAttivi")).prenotazioneIsEnable;
            if(prenotazioneIsEnable) {
                next();
            } else {
                next(false);
            }
        }

    },
    // {
    //     path: '/riepilogo',
    //     name: 'Riepilogo',
    //     component: riepilogo,

    // },
    // {
    //   path: '/proposte',
    //   name: 'proposte',
    //   component: proposte,

    // },
    {
        path: '/listaappuntamenti',
        name: 'listaappuntamenti',
        component: listaappuntamenti,
        beforeEnter: (to, from, next) => {
            var appuntamentiIsEnable = JSON.parse(sessionStorage.getItem("serviziAttivi")).appuntamentiIsEnable;
            if(appuntamentiIsEnable) {
                next()
            } else {
                next(false)
            }
        }

    },
    {
        path: '/listapendenze',
        name: 'listapendenze',
        component: listaPendenze,
        beforeEnter: (to, from, next) => {
            var pagamentiIsEnable = JSON.parse(sessionStorage.getItem("serviziAttivi")).pagamentiIsEnable;
                if(pagamentiIsEnable) {
                    next()
                } else {
                    next(false)
                }
            }

    },
    {
        path: '/contattaci',
        name: 'contattaci',
        component: contattaci,

    },
    {
        path: '/pagamentoconfermato',
        name: 'pagamentoconfermato',
        component: pagamentoConfermato,

    },
    {
        path: '/errorepagamento',
        name: 'errorepagamento',
        component: errorePagamento,

    },
    {
        path: '/storicopagamenti',
        name: 'storicopagamenti',
        component: storicoPagamenti,

    },
    {
        path: "/registratispid",
        name: "registratispid",
        component: registratiSpid,
    },
    {
        path: "/faq",
        name: "faq",
        component: faq,
    },
    {
      path: '/contatti',
      name: 'contatti',
      component: contatti,
      beforeEnter: (to, from, next) => {
        var contattiIsEnable = JSON.parse(sessionStorage.getItem("serviziAttivi")).contattiIsEnable;
            if(contattiIsEnable) {
                next()
            } else {
                next("/")
            }
        }
    },
]

const routes = [
    {
        path: '/',
        name: 'login',
        component: login,
    },
    {
        path: '/home',
        component: main,
        children: mainChildren,
    },
    {
        path: '/oauth_redirect',
        name: 'oauthRedirect',
        component: oauthRedirect,
    },
    {
        path: '/redirect_fse',
        name: 'redirect_fse',
        component: oauthRedirectFSE,
    }
]

const router = new VueRouter({
    routes,
    mode: "history",
    base: process.env.BASE_URL,
});

// router.beforeEach(async (to, from, next) => {
//   // if (to.path === '/login' || to.path === '/')
//   //   next();
//   // else {
//   //   const user = await authService.getUser();
//   //   if (user == null)
//   //     next("/");
//   // }
// });

router.beforeEach((to, from, next) => {
    const token = sessionStorage.getItem('loginData')
    if (!token && to.name !== 'login' && to.name !== 'oauthRedirect' && to.name !== 'redirect_fse' && to.name !== 'contattaci' && to.name !== 'pagamentoconfermato' && to.name !== 'errorepagamento') {
        next({name: 'login'});
    } else {
        next();
    }
});

export default router

